// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Enum for messages and error descriptions to be translated in the web client.
 * @export
 */
export const TranslationKey = {
  FileTooLargeToProcess: "file_too_large_to_process",
  FileProcessUnknownError: "file_process_unknown_error",
  LizardScenarioProcessingError: "lizard_scenario_processing_error",
  FileFormatUnsupported: "file_format_unsupported",
  FileIncompleteOrCorrupt: "file_incomplete_or_corrupt",
  FileHasInvalidCrs: "file_has_invalid_crs",
  RasterHasNoBands: "raster_has_no_bands",
  VectorHasNoLayers: "vector_has_no_layers",
  FileProcessMemoryConstraints: "file_process_memory_constraints",
  UnpackedFileTooLarge: "unpacked_file_too_large",
  PublicationVersionAlreadyExists: "publication_version_already_exists",
  FileOrDirectoryAlreadyExists: "file_or_directory_already_exists",
  ShapefileSidecarFilesMissing: "shapefile_sidecar_files_missing",
} as const;
export type TranslationKey = (typeof TranslationKey)[keyof typeof TranslationKey];

export function instanceOfTranslationKey(value: any): boolean {
  for (const key in TranslationKey) {
    if (Object.prototype.hasOwnProperty.call(TranslationKey, key)) {
      if (TranslationKey[key as keyof typeof TranslationKey] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TranslationKeyFromJSON(json: any): TranslationKey {
  return TranslationKeyFromJSONTyped(json, false);
}

export function TranslationKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TranslationKey {
  return json as TranslationKey;
}

export function TranslationKeyToJSON(value?: TranslationKey | null): any {
  return value as any;
}

export function TranslationKeyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): TranslationKey {
  return value as TranslationKey;
}
